export default __webpack_public_path__ + "static/media/login_design.d29f877e.svg";